// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-8d4f7764] {\n  margin-bottom: 16px;\n  color: #17233d;\n  font-weight: 500;\n  font-size: 14px;\n}\n.description-term[data-v-8d4f7764] {\n  display: table-cell;\n  padding-bottom: 10px;\n  line-height: 20px;\n  width: 50%;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
